import { render, staticRenderFns } from "./EmbargoGoInaConsultaLista.vue?vue&type=template&id=91c5a9e4&lang=pug"
import script from "./EmbargoGoInaConsultaLista.vue?vue&type=script&lang=js"
export * from "./EmbargoGoInaConsultaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports